import { useNavigate, useParams } from "react-router-dom";
import { useAddOrderMutation } from "@/features/organizations/api/ordersApi";
import useSnackbar from "@/hooks/useSnackbar";
import { Order } from "@/types";
import _ from "lodash";

export const useResumeOrder = () => {
  const navigate = useNavigate();
  const { organizationId } = useParams<{ organizationId: string }>();
  const [addOrder] = useAddOrderMutation();
  const [openSnackbar] = useSnackbar();

  const handleResumeOrder = async (order: Order, onSuccess?: () => void) => {
    if (window.confirm("¿Estás seguro de que deseas retomar este pedido?")) {
      const newOrderPayload: Partial<Order> = {
        ...order,
        status: "preparing" as any,
        createdAt: Date.now(),
        orderedAt: Date.now(),
        number: Number(_.times(4, () => _.random(0, 9)).join("")),
      };

      delete newOrderPayload.id;
      delete newOrderPayload.rejectedReason;
      delete newOrderPayload.rejectedAt;
      delete newOrderPayload.rejectedBy;
      delete newOrderPayload.completedAt;
      delete newOrderPayload.completedBy;

      try {
        if (organizationId) {
          await addOrder({ organizationId, order: newOrderPayload });
          navigate("?tab=incoming");
          if (onSuccess) onSuccess();
        }
      } catch (e) {
        openSnackbar("Error al retomar la order", "error");
      }
    }
  };

  return { handleResumeOrder };
};

export default useResumeOrder;
